<app-back-header
  [headerText]="'Torna alla dashboard'"
  (backAction)="backToDashboard()"
  class="sticky-top">
</app-back-header>

<h3 class="ms-2 mt-2 mb-3">Importa Corrispettivo Elettronico (RT)</h3>

<div class="upload-container col-md-6">

  <form [formGroup]="uploadForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label for="xmlFile" class="upload-field-label mb-2">File XML Corrispettivi</label>

      <!-- Drag & Drop Area: superficie piatta bianca con contorno nero 2px
           tratteggiato (il tratteggio dice "qui si trascina") e angolo
           basso-sinistra vivo a 90°, come le altre superfici BEIZY. -->
      <div
        class="drop-zone izy-sharp-bl"
        [class.drop-zone--over]="isDragOver"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
        (click)="fileInput.click()">

        <div class="drop-zone-content">
          <mat-icon class="drop-zone-icon">receipt_long</mat-icon>

          <div *ngIf="!selectedFile" class="drop-zone-text">
            <p class="mb-1">Trascina qui il file XML del corrispettivo</p>
            <p class="drop-zone-subtext mb-0">o clicca per selezionarlo</p>
          </div>

          <!-- File scelto: riga bianca bordata nera 2px dentro l'area, come le
               voci di lista delle card di nuova fattura (.izy-item-card). -->
          <div *ngIf="selectedFile" class="selected-file izy-sharp-bl">
            <mat-icon class="file-icon">description</mat-icon>
            <div class="file-info">
              <strong>{{ selectedFile.name }}</strong>
              <small class="file-size d-block">
                Dimensione: {{ (selectedFile.size / 1024).toFixed(2) }} KB
              </small>
            </div>
            <button
              mat-icon-button
              type="button"
              (click)="removeFile($event)"
              aria-label="Rimuovi il file scelto"
              class="remove-btn">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <input
        #fileInput
        type="file"
        id="xmlFile"
        (change)="onFileSelected($event)"
        accept=".xml"
        style="display: none"
        required>

      <div *ngIf="!selectedFile" class="mt-3">
        <small class="upload-hint">
          Seleziona un file XML generato dal tuo Registratore Telematico, poi premi "Importa".
        </small>
        <small class="upload-hint mt-1">
          I dati relativi a chiusura giornaliera e IVA verranno estratti automaticamente.
        </small>
      </div>
    </div>

    <!-- Riepilogo dei dati letti dall'XML: card bianca bordata nera 2px con la
         testata su fondo panna separata dal tratto nero, la stessa fascia dei
         footer delle card fattura/notifica. -->
    <div *ngIf="selectedFile && !uploadSuccess" class="mt-3 data-preview-card izy-sharp-bl custom-card-border">
      <p class="data-preview-title">Dati rilevati dal file</p>
      <ul class="list-unstyled mb-0 data-preview-list">
        <li class="data-preview-row">
          <mat-icon class="data-preview-icon">calendar_today</mat-icon>
          <span class="data-preview-label">Data di emissione</span>
          <strong>{{ closingDate }}</strong>
        </li>
        <li class="data-preview-row">
          <mat-icon class="data-preview-icon">qr_code</mat-icon>
          <span class="data-preview-label">Matricola RT</span>
          <strong>{{ deviceId }}</strong>
        </li>
        <li class="data-preview-row">
          <mat-icon class="data-preview-icon">tag</mat-icon>
          <span class="data-preview-label">Progressivo</span>
          <strong>{{ progressiveNumber }}</strong>
        </li>
        <li class="data-preview-row">
          <mat-icon class="data-preview-icon">pin</mat-icon>
          <span class="data-preview-label">Numero Scontrini</span>
          <strong>{{ nDocs }}</strong>
        </li>
        <li class="data-preview-row">
          <mat-icon class="data-preview-icon">euro</mat-icon>
          <span class="data-preview-label">Totale Lordo</span>
          <strong>€ {{ formatToItalian(totalAmount) }}</strong>
        </li>
      </ul>
    </div>

    <!-- Azione primaria della schermata: pillola petrol con bordo nero 2px. -->
    <div class="mt-3 form-actions d-flex justify-content-end gap-2">
      <button
        matButton="filled"
        type="submit"
        [disabled]="!uploadForm.valid || isUploading || !selectedFile"
        class="izy-button-primary custom-button-border">
        <mat-icon *ngIf="!isUploading">upload</mat-icon>
        <mat-spinner *ngIf="isUploading" diameter="20" class="d-inline-block me-2 izy-button-spinner"></mat-spinner>
        {{ isUploading ? 'Importando...' : 'Importa XML' }}
      </button>
    </div>

    <div *ngIf="uploadProgress > 0" class="progress mt-3">
      <div
        class="progress-bar"
        [style.width]="uploadProgress + '%'">
        {{ uploadProgress }}%
      </div>
    </div>

    <!-- Esiti: stessa card bianca bordata nera 2px del resto della pagina, con
         una fascia di colore a sinistra come segnale (rosso per l'errore, lime
         per l'esito positivo, lo stesso segnale delle notifiche da leggere). -->
    <div *ngIf="uploadError" class="upload-alert upload-alert--error izy-sharp-bl custom-card-border mt-3">
      <mat-icon class="upload-alert-icon">error_outline</mat-icon>
      <span>{{ uploadError }}</span>
    </div>

    <div *ngIf="uploadSuccess" class="upload-alert upload-alert--success izy-sharp-bl custom-card-border mt-3">
      <div class="d-flex align-items-start mb-3">
        <mat-icon class="me-2 flex-shrink-0 upload-alert-icon">check_circle</mat-icon>
        <div>
          <strong>Chiusura RT {{deviceId}} importata!</strong>
          <p class="mb-0 upload-alert-detail">Il corrispettivo progressivo N.{{progressiveNumber}} è stato registrato correttamente.</p>
        </div>
      </div>

      <div class="d-flex flex-wrap gap-2">
        <button
          matButton="filled"
          (click)="navigateToCorrispettivi()"
          class="izy-button-primary custom-button-border">
          <mat-icon>list</mat-icon> Lista Corrispettivi
        </button>

        <button
          mat-stroked-button
          (click)="prepareNewUpload()"
          class="izy-button-ghost custom-button-border">
          <mat-icon>refresh</mat-icon> Carica un altro
        </button>
      </div>
    </div>

  </form>
</div>

<div class="pt-5 mt-5"></div>
